import { useEffect, useState } from "react";

const useMediaQueryHeight = (minHeight:number) => {
    const [state, setState] = useState({
        windowHeight: window.innerHeight,
        isDesiredHeight: false,
    });
    useEffect(() => {

            const currentWindowHeight = window.innerHeight;
            const isDesiredHeight = currentWindowHeight < minHeight;
            setState({ windowHeight: currentWindowHeight, isDesiredHeight });

    }, [minHeight]);

    useEffect(() => {
        const resizeHandler = () => {
            const currentWindowHeight = window.innerHeight;
            const isDesiredHeight= currentWindowHeight < minHeight;
            setState({ windowHeight: currentWindowHeight, isDesiredHeight });
        };
        window.addEventListener("resize", resizeHandler);
        return () => window.removeEventListener("resize", resizeHandler);
    }, [state.windowHeight,minHeight,window.pageYOffset]);

    return state.isDesiredHeight;
};


export default useMediaQueryHeight;